import { createSlice } from '@reduxjs/toolkit';
import { fetchReportsByFilter } from './reportThunk';

const reportSlice = createSlice({
  name: 'report',
  initialState: {
    reports: [],
    selectedReport: null,
  },
  reducers: {
    setReports: (state, action) => {
      state.reports = action.payload;
    },
    setSelectedReport: (state, action) => {
      state.selectedReport = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchReportsByFilter.fulfilled, (state, action) => {
      state.reports = action.payload;
    });
    builder.addCase(fetchReportsByFilter.rejected, (state, action) => {
      console.error("API failed:", action.payload);
    });
  },
});

export const { setReports, setSelectedReport } = reportSlice.actions;
export default reportSlice.reducer;
